import { StyleSheet } from 'react-native';

/**
 * Floodlit-stadium artwork colors. Illustration tokens (a night sky over a lit pitch),
 * not part of the app's semantic theme palette — so they live here as named constants.
 *
 * Composition: `expo-linear-gradient` for the sky / pitch / veil, plain Views for the mow
 * stripes + pitch markings (both web-safe), and `react-native-svg` radial gradients for the
 * floodlight blooms (the same lib SoccerKit uses, so it renders on web too). If the SVG
 * blooms ever fail, the gradient + View layers still read as a stadium.
 */
export const STADIUM_SKY_COLORS = ['#120A26', '#1E1142', '#150C30'] as const;
export const STADIUM_PITCH_COLORS = ['#177A42', '#0E5530', '#073A1F'] as const;
export const STADIUM_PITCH_FADE = ['#150C30', 'rgba(21,12,48,0)'] as const;
export const STADIUM_VEIL_COLORS = ['rgba(5,3,12,0)', 'rgba(5,3,12,0.55)'] as const;
export const STADIUM_VEIL_LOCATIONS = [0.48, 1] as const;

/** Floodlight bloom tints (soft violet-white) for the SVG radial glows. */
export const STADIUM_FLOOD_SIDE = '#DCD2FF';
export const STADIUM_FLOOD_CENTER = '#9678FF';

/** Mow-stripe tints + marking lines. */
export const STADIUM_STRIPE_LIGHT = 'rgba(255,255,255,0.06)';
export const STADIUM_STRIPE_DARK = 'rgba(0,0,0,0.06)';
export const STADIUM_MARKING = 'rgba(255,255,255,0.22)';

/** Number of vertical mow stripes painted across the pitch. */
export const STADIUM_STRIPE_COUNT = 10;

export const matchHubHeroBackgroundStyles = StyleSheet.create({
  fill: {
    ...StyleSheet.absoluteFillObject,
  },
  /** Lower half of the hero holds the lit pitch. */
  pitchBand: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: '50%',
    overflow: 'hidden',
  },
  stripeRow: {
    ...StyleSheet.absoluteFillObject,
    flexDirection: 'row',
  },
  stripe: {
    flex: 1,
  },
  stripeLight: {
    backgroundColor: STADIUM_STRIPE_LIGHT,
  },
  stripeDark: {
    backgroundColor: STADIUM_STRIPE_DARK,
  },
  /** Halfway line near the top of the pitch band. */
  pitchLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '16%',
    height: 2,
    backgroundColor: STADIUM_MARKING,
  },
  /** Centre circle, flattened with scaleY so it reads in perspective. */
  pitchCircle: {
    position: 'absolute',
    alignSelf: 'center',
    top: '16%',
    width: 132,
    height: 132,
    marginTop: -66,
    borderWidth: 2,
    borderColor: STADIUM_MARKING,
    borderRadius: 66,
    transform: [{ scaleY: 0.42 }],
  },
  /** Soft fade blending the pitch top into the night sky (no hard seam). */
  pitchTopFade: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 50,
  },
});
